export type Project = {
  id: string
  type: string
  location: string
  services: string[]
  description: string
  image: string
}

export const projects: Project[] = [
  {
    id: 'p1',
    type: 'Kitchen Renovation',
    location: 'Prospect, KY',
    services: ['Cabinet Refinishing', 'Trim Work', 'Interior Painting'],
    description:
      'A closed-off kitchen opened up with custom cabinetry, refreshed millwork, and a hand-finished paint job throughout.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/03a9d778-f269-4170-beef-9a974063899a.jpg',
  },
  {
    id: 'p2',
    type: 'Exterior Repaint',
    location: 'Lexington, KY',
    services: ['Exterior Painting', 'Trim & Shutters', 'Surface Prep'],
    description:
      'Full exterior prep and repaint on a historic brick home, with crisp trim lines and durable, weather-ready coatings.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6d28c374-b30c-4a85-8215-da4940defed1.jpg',
  },
  {
    id: 'p3',
    type: 'Primary Bath Remodel',
    location: 'Louisville, KY',
    services: ['Bathroom Remodeling', 'Tile Work', 'Finish Carpentry'],
    description:
      'A cramped bath reworked into a calm, spa-inspired retreat with marble tile and warm brass fixtures.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2adf5ff0-22e8-4679-9e77-e174e2648289.jpg',
  },
  {
    id: 'p4',
    type: 'Home Office Build-Out',
    location: 'Crestwood, KY',
    services: ['Built-Ins', 'Interior Painting', 'Trim & Finish Work'],
    description:
      'Floor-to-ceiling built-ins finished in a deep charcoal, paired with detailed casing and picture lighting.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4db1e9c9-69cd-4945-9a49-adf525f17b50.jpg',
  },
  {
    id: 'p5',
    type: 'Mudroom & Laundry',
    location: 'Bowling Green, KY',
    services: ['Home Remodeling', 'Custom Lockers', 'Interior Painting'],
    description:
      'An underused hallway turned into a hardworking mudroom with custom lockers and durable finishes.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d002c227-9ddb-4e6a-9853-1044ae9b3d2b.jpg',
  },
  {
    id: 'p6',
    type: 'Living Room Refresh',
    location: 'Frankfort, KY',
    services: ['Fireplace Refinishing', 'Interior Painting', 'Trim Work'],
    description:
      'A tired brick fireplace refinished and framed with new millwork to anchor the whole room.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/13342f46-fcae-4292-b703-55476b71efc8.jpg',
  },
]
